import { render, staticRenderFns } from "./ed-edupad-history.vue?vue&type=template&id=0ece1f95&scoped=true&"
import script from "./ed-edupad-history.ts?vue&type=script&lang=ts&"
export * from "./ed-edupad-history.ts?vue&type=script&lang=ts&"
import style0 from "./ed-edupad-history.scss?vue&type=style&index=0&id=0ece1f95&lang=scss&scoped=true&"
import style1 from "@/assets/styles/quill.snow.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ece1f95",
  null
  
)

export default component.exports